import React from "react";
import TaxCard from "./TaxCard";
import { css } from "emotion";
import { Highlight } from "../../search/Highlight";
import { getRequest } from "../../../helpers/ApiHelpers";
import { convertToFileDownload } from "../../../helpers/ConvertToFileDownload";
import { getAnswer } from "../../../helpers/GetAnswer";
import DOMPurify from "dompurify";

const sanitizeNote = (note) => {
  if (!note) return "";
  const html = /<p>|<\/p>|<br\s*\/?>|<strong>|<\/strong>|<em>|<\/em>|<u>|<\/u>|<s>|<\/s>|<ol>|<ul>|<li>|<span/i.test(note)
    ? note
    : note.split(/\r\n|\r|\n/).map(line => `<p>${line || "<br>"}</p>`).join("");
  return DOMPurify.sanitize(html);
};

const paragraphStyles = css({
  color: "#000",
  fontSize: 14,
  lineHeight: 1.5,
  whiteSpace: "pre-wrap"
});
const labelStyles = css({
  fontFamily: "Fakt-Bold",
  fontSize: 14,
  color: "#707898",
  marginBottom: 14,
  marginTop: 24
});

const hasContent = (string) => {
  if (!string) return false;
  const text = string.replace(/<[^>]*>/g, "").replace(/\s/g, "");
  return text.length > 0;
};

const checkIfEmpty = (bool, string) => {
  return bool === true || bool === false || hasContent(string);
};


async function download(id) {
  const result = await getRequest(`/tax/downloadMortgageTaxFile?id=${id}`);
  if (result.success) {
    convertToFileDownload(result.data.base64File, result.data.name);
  }
}

function MortgageTax({ tax, editRoute }) {
  return (
    <TaxCard
      title="Mortgage Tax"
      isApplicable={tax.isApplicable}
      editRoute={editRoute}
    >
      {hasContent(tax.isApplicableNote) && (
        <div
          className={`ql-editor ${css({ "& p": { margin: "0 !important" } })}`}
          dangerouslySetInnerHTML={{ __html: sanitizeNote(tax.isApplicableNote) }}
        />
      )}
      {checkIfEmpty(
        tax.isExemptOfAssumptionOfMortgage,
        tax.isExemptOfAssumptionOfMortgageNote
      ) && (
        <React.Fragment>
          <div className={labelStyles}>
            Is the Assumption of Mortgage exempt from tax?
          </div>
          <p className={paragraphStyles}>{getAnswer(tax.isExemptOfAssumptionOfMortgage)}</p>
          {hasContent(tax.isExemptOfAssumptionOfMortgageNote) && (
            <div
              className={`ql-editor ${css({ "& p": { margin: "0 !important" } })}`}
              dangerouslySetInnerHTML={{ __html: sanitizeNote(tax.isExemptOfAssumptionOfMortgageNote) }}
            />
          )}
        </React.Fragment>
      )}
      {checkIfEmpty(
        tax.isExemptOfAssignmentOfMortgage,
        tax.isExemptOfAssignmentOfMortgageNote
      ) && (
        <React.Fragment>
          <div className={labelStyles}>
            Is the Assignment of Mortgage exempt from tax?
          </div>
          <p className={paragraphStyles}>{getAnswer(tax.isExemptOfAssignmentOfMortgage)}</p>
          {hasContent(tax.isExemptOfAssignmentOfMortgageNote) && (
            <div
              className={`ql-editor ${css({ "& p": { margin: "0 !important" } })}`}
              dangerouslySetInnerHTML={{ __html: sanitizeNote(tax.isExemptOfAssignmentOfMortgageNote) }}
            />
          )}
        </React.Fragment>
      )}
      {tax.mortgageTaxFiles && tax.mortgageTaxFiles.length > 0 && (
        <div className={labelStyles}>Attachments</div>
      )}
      {tax.mortgageTaxFiles &&
        tax.mortgageTaxFiles.map(f => (
          <p className={paragraphStyles} key={f.id}>
            <a
              onClick={() => download(f.id)}
              className={css({
                "&:hover": { textDecoration: "underline", color: "#00b8d4" }
              })}
            >
              <i
                className="fal fa-paperclip"
                style={{ color: "#00b8d4", marginRight: 8 }}
              />
              <Highlight children={f.fileName} />
            </a>
          </p>
        ))}
    </TaxCard>
  );
}

export default React.memo(MortgageTax);
